

.pagination
{
  display: flex;
  gap: .6em;
  justify-content: center;
  margin: 1.5em;

  span {
    background-color: white;
    color: var(--beigedarker);
    padding: 0.3em 0.8em;
    border-radius: var(--border-radius);
    transition: 0.25s;

    &.link {
      cursor: pointer;

      &:hover {
        color: white;
        background-color: var(--beigedarker)
      }
    }

    &.current {
      color: white;
      background-color: var(--beigedarker);
    }

    &.dots {
      background-color: transparent;
    }
  }


}
